import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RestService } from '../../../../../service/rest.service';
import { forkJoin } from 'rxjs';
import { FileElement } from '../../../../../models/app.model';
import { HelperSystem } from '../../../../../shared/helpers/helper.system';
import { AppConfig } from '../../../../../shared/configs/app.config';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {

  @ViewChild('fileUpload') file;
  public files: Set<File> = new Set();
  public fileElements: Array<FileElement> = [];
  progress: any;
  canBeClosed = true;
  showCancelButton = true;
  uploading = false;
  uploadSuccessful = false;
  primaryButtonText = 'Загрузить';

  uploadPath: string;
  fileUploadSize: number;
  fileUploadType: string;
  fileUploadError: boolean;
  photoBookMode: boolean = false;

  constructor(public dialogRef: MatDialogRef<FileUploadDialogComponent>,
              private restService: RestService) { }

  ngOnInit() {
    if (!this.uploadPath) {
      throw new Error('Upload path isn\'t detected!');
    }
    this.fileUploadSize = 51200; // AppConfig.UPLOAD_FILE_FILESIZE;
    this.fileUploadType = !this.photoBookMode ? AppConfig.UPLOAD_FILE_FILETYPE : AppConfig.UPLOAD_FILE_FILETYPE_PHOTO_BOOK;
  }

  onFilesAdded() {
    const files: { [key: string]: File } = this.file.nativeElement.files;
    const fileElement = <FileElement>{};
    this.fileUploadError = false;

    for (const key in files) {
      if (!isNaN(parseInt(key, 10))) {
        // check, files[key].size is presented in bytes here
        if ( (files[key].size / 1024) > this.fileUploadSize ) {
          this.fileUploadError = true;
          return;
        }

        // @todo: check file upload type

        // init file elements
        fileElement.id = HelperSystem.generateUUID();
        fileElement.path = this.uploadPath;
        fileElement.size = files[key].size;
        fileElement.uploadName = files[key].name;
        // fileElement.uploadDate = files[key].lastModified; <-- it might throw you off
        this.fileElements.push(fileElement);
        this.files.add(files[key]);
      }
    }
  }

  closeDialog() {
    // set the component state to "uploading"
    this.uploading = true;
    // start the upload and save the progress map
    this.progress = this.restService.fileUpload(this.files, this.uploadPath);

    for (const key in this.progress) {
      if (this.progress.hasOwnProperty(key)) {
        // this.progress[key].progress.subscribe(val => console.log(val));
      }
    }

    // convert the progress map into an array
    const allProgressObservables = [];
    for (const key in this.progress) {
      if (this.progress.hasOwnProperty(key)) {
        allProgressObservables.push(this.progress[key].progress);
      }
    }

    // Adjust the state variables

    // The dialog should not be closed while uploading
    this.canBeClosed = false;
    this.dialogRef.disableClose = true;

    // Hide the cancel-button
    this.showCancelButton = false;

    // When all progress-observables are completed...
    forkJoin(allProgressObservables).subscribe(end => {
      // ... the dialog can be closed again...
      // this.canBeClosed = true;
      this.dialogRef.disableClose = false;
      // ... the upload was successful...
      this.uploadSuccessful = true;
      // ... and the component is no longer uploading
      this.uploading = false;
      // The OK-button should have the text "Finish" now
      this.primaryButtonText = 'Загружено';
    });
  }

}
